import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { FormDataUpload, NestApiProvider } from '../../nest-api';
import {
  RequestAddAndUpdateLeaveEntGradeDto,
  RequestAddDto,
  RequestApproveDto,
  RequestApproveRejectDto,
  RequestCancelDto,
  RequestCheckEmployeeOptionDto,
  RequestDeleteDraftDto,
  RequestGetBalanceLeaveDto,
  RequestGetLeaveHistoryDto,
  RequestGetLeaveReqApprovalDto,
  RequestGetLeaveTypeFormDto,
  RequestPaginationDto,
  RequestSaveDraftDto,
  ResponseAddAndUpdateLeaveEntGradeDto,
  ResponseAddDto,
  ResponseApproveDto,
  ResponseApproveRejectDto,
  ResponseCancelDto,
  ResponseDeleteDraftDto,
  ResponseDeleteLeaveEntGradeDto,
  ResponseGetBalanceLeaveDto,
  ResponseGetLeaveEntDto,
  ResponseGetLeaveHistoryDto,
  ResponseGetLeaveReqApprovalDto,
  ResponseGetLeaveTypeDto,
  ResponseGetLeaveTypeFormDto,
  ResponseGetRequestInboxDto,
  ResponseGetTypeLeaveParent,
  ResponseSaveDraftDto
} from '../dto/sf-leave-request.dto';
import { ResponseData } from '../../nest-responses';

@Injectable()
export class SfLeaveRequestApi {

  private service: string = '';
  private model: string = 'sfLeaveRequest';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getbalanceleave(payload: RequestGetBalanceLeaveDto): Observable<ResponseGetBalanceLeaveDto> {
    const method: string = 'POST';
    const func: string = 'getbalanceleave';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetBalanceLeaveDto>(method, url, params, urlParams, body);
  }

  public getLeaveHistory(payload: RequestGetLeaveHistoryDto, page: string | number, limit: string | number): Observable<ResponseGetLeaveHistoryDto> {
    const method: string = 'POST';
    const func: string = 'getLeaveHistory';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) urlParams.page = page;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetLeaveHistoryDto>(method, url, params, urlParams, body);
  }

  public getLeaveTypeForm(payload: RequestGetLeaveTypeFormDto): Observable<ResponseGetLeaveTypeFormDto> {
    const method: string = 'POST';
    const func: string = 'getLeaveTypeForm';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetLeaveTypeFormDto>(method, url, params, urlParams, body);
  }

  public getLeaveReqApproval(payload: RequestGetLeaveReqApprovalDto): Observable<ResponseGetLeaveReqApprovalDto> {
    const method: string = 'POST';
    const func: string = 'getLeaveReqApproval';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetLeaveReqApprovalDto>(method, url, params, urlParams, body, null, 60000);
  }

  public add(payload: RequestAddDto): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body);
  }

  public saveDraft(payload: RequestSaveDraftDto): Observable<ResponseSaveDraftDto> {
    const method: string = 'POST';
    const func: string = 'saveDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDraftDto>(method, url, params, urlParams, body);
  }

  public cancel(payload: RequestCancelDto): Observable<ResponseCancelDto> {
    const method: string = 'POST';
    const func: string = 'cancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCancelDto>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestApproveDto): Observable<ResponseApproveDto> {
    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveDto>(method, url, params, urlParams, body);
  }

  public revise(payload: RequestApproveRejectDto): Observable<ResponseApproveRejectDto> {
    const method: string = 'POST';
    const func: string = 'revise';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveRejectDto>(method, url, params, urlParams, body);
  }

  public reject(payload: RequestApproveRejectDto): Observable<ResponseApproveRejectDto> {
    const method: string = 'POST';
    const func: string = 'reject';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseApproveRejectDto>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: RequestDeleteDraftDto): Observable<ResponseDeleteDraftDto> {
    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDraftDto>(method, url, params, urlParams, body);
  }

  public downloadTemplate(leaveCode: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof leaveCode !== 'undefined' && leaveCode !== null) urlParams.leaveCode = leaveCode;

    const _url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, _url, func, params, body);
  }

  public downloadLeaveSetup(leaveCode: string) {
    const method: string = 'GET';
    const func: string = 'downloadLeaveSetup';
    const params: any = {};
    const urlParams: any = {};
    // const body: any = {};

    if (typeof leaveCode !== 'undefined' && leaveCode !== null) urlParams.type = leaveCode;

    const _url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return _url;
  }

  public uploadLeaveSetup(file: File, leaveCode: string): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadLeaveSetup';
    const params: FormDataUpload[] = [];
    params.push({ name: 'file', value: file }, { name: 'leaveCode', value: leaveCode });
    const urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, _url, params);
  }

  public getLeaveEnt(queryParams: { page: number, limit: number }): Observable<ResponseGetLeaveEntDto> {
    const method: string = 'GET';
    const func: string = 'getLeaveEnt';
    const params: any = {};
    const urlParams: any = queryParams;
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetLeaveEntDto>(method, url, func, params, body);
  }

  public addLeaveEntGrade(data: RequestAddAndUpdateLeaveEntGradeDto): Observable<ResponseAddAndUpdateLeaveEntGradeDto> {
    const method: string = 'POST';
    const func: string = 'addLeaveEntGrade';
    const params: RequestAddAndUpdateLeaveEntGradeDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddAndUpdateLeaveEntGradeDto>(method, url, params, urlParams, body);
  }

  public editLeaveEntGrade(data: RequestAddAndUpdateLeaveEntGradeDto): Observable<ResponseAddAndUpdateLeaveEntGradeDto> {
    const method: string = 'POST';
    const func: string = 'editLeaveEntGrade';
    const params: RequestAddAndUpdateLeaveEntGradeDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddAndUpdateLeaveEntGradeDto>(method, url, params, urlParams, body);
  }

  public deleteLeaveEntGrade(data): Observable<ResponseDeleteLeaveEntGradeDto> {
    const method: string = 'POST';
    const func: string = 'deleteLeaveEntGrade';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteLeaveEntGradeDto>(method, url, params, urlParams, body);
  }

  checkEmployeeOption(payload: RequestCheckEmployeeOptionDto, pagination: RequestPaginationDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'checkEmployeeOption';
    const params: any = payload;
    const urlParams: any = pagination;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType);
  }

  getrequestinbox(data): Observable<ResponseGetRequestInboxDto> {
    const method: string = 'POST';
    const func: string = 'getrequestinbox';
    const params: any = {
      requestNo: data
    };
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetRequestInboxDto>(method, url, params, urlParams, body);
  }

  public getLeaveType(): Observable<ResponseData<ResponseGetLeaveTypeDto[]>> {
    const method: string = 'POST';
    const func: string = 'getLeaveType';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetLeaveTypeDto[]>>(method, url, params, urlParams, body);
  }

  public getTypeLeaveParent(): Observable<ResponseData<ResponseGetTypeLeaveParent[]>> {
    const method: string = 'POST';
    const func: string = 'getTypeLeaveParent';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetTypeLeaveParent[]>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-leave-request.api.ts